import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import ListTemplate from "@/templates/PromptTemplate/ListTemplate";
import usePromptTemplateList from "./usePromptTemplateList";

export default function PromptTemplateListPage() {
  const {
    data,
    loading,
    categories,
    selectedCategory,
    searchKeyword,
    handleCategoryChange,
    handleSearch,
    handleCreate,
    handleDetail,
    handleDelete,
    handlePageChange,
    handleRowsPerPageChange,
  } = usePromptTemplateList();

  return (
    <Container maxWidth={"xl"}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Typography
          component={"h1"}
          variant="h5"
          fontWeight={"bold"}
          gutterBottom
        >
          프롬프트 템플릿 관리
        </Typography>
        <Button variant="contained" startIcon={<Add />} onClick={handleCreate}>
          Create Template
        </Button>
      </Box>

      <ListTemplate
        data={data}
        loading={loading}
        categories={categories}
        selectedCategory={selectedCategory}
        searchKeyword={searchKeyword}
        onCategoryChange={handleCategoryChange}
        onSearch={handleSearch}
        onDetail={handleDetail}
        onDelete={handleDelete}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </Container>
  );
}
